import { useTheme } from "@emotion/react";
import {
  Cancel,
  CheckCircle,
  Clear,
  ExpandMore,
  ManageAccountsOutlined,
  Search,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  CircularProgress,
  Collapse,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import api from "../../../../../../services/api";
import DatagridComponent from "../../../../../../components/datagridComponent";
import useStyles from "./styles";

export default function ConfigSuporte() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;
  const [configClienteGlobal, setConfigClienteGlobal] = useState({
    openTicket: false,
    finishTicket: false,
    sendMessage: false,
    sendAnexo: false,
  });

  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [duplicateTicketWindow, setDuplicateTicketWindow] = useState({
    ativo: false,
    valor: 1,
    unidade: "horas",
  });
  const [suporteGeneralSettings, setSuporteGeneralSettings] = useState({});
  const [configCliente, setConfigCliente] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buscarCliente, setBuscarCliente] = useState("");
  const [snackbar, setSnackbar] = useState(null);
  const filteredRows = configCliente?.filter((row, index) => {
    row.numero = index;

    return (
      row.nome
        ?.toLowerCase()
        ?.includes(buscarCliente?.toLowerCase()?.trim())
    );
  });

  const openTicketLiberadoGlobal = configClienteGlobal?.openTicket;
  const sendMessageLiberadoGlobal = configClienteGlobal?.sendMessage;
  const sendAnexoLiberadoGlobal = configClienteGlobal?.sendAnexo;

  const columnsCliente = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "cliente",
      headerName: "cliente",
      flex: 1,
      renderCell: (params) => {
        return params.row.nome || "";
      },
    },
    !openTicketLiberadoGlobal && {
      field: "openTicket",
      headerName: "Permitir abrir ticket",
      width: 200,
      renderCell: (params) => (
        <Switch
          disabled={loadingUpdate}
          size="small"
          checked={params.row.openTicket}
          onChange={(e) => {
            updateConfigCliente(params?.row?.id, e.target.checked);
          }}
          focusVisibleClassName=".Mui-focusVisible"
          disableRipple
        />
      ),
    },
    !sendMessageLiberadoGlobal && {
      field: "sendMessage",
      headerName: "Permitir enviar mensagem",
      width: 200,
      renderCell: (params) => (
        <Switch
          disabled={loadingUpdate}
          size="small"
          checked={params.row.sendMessage}
          onChange={(e) => {
            updateConfigCliente(params?.row?.id, null, e.target.checked);
          }}
          focusVisibleClassName=".Mui-focusVisible"
          disableRipple
        />
      ),
    },
    !sendAnexoLiberadoGlobal && {
      field: "sendAnexo",
      headerName: "Permitir anexar arquivo",
      width: 200,
      renderCell: (params) => (
        <Switch
          disabled={loadingUpdate}
          size="small"
          checked={params.row.sendAnexo}
          onChange={(e) => {
            updateConfigCliente(params?.row?.id, null, null, e.target.checked);
          }}
          focusVisibleClassName=".Mui-focusVisible"
          disableRipple
        />
      ),
    },
  ].filter(Boolean);

  useEffect(() => {
    getConfig();
  }, []);

  const getConfig = async () => {
    setLoading(true);
    try {
      const response = await api.get("/interno/find/configClientes");

      setConfigClienteGlobal(response?.data?.configGlobal);
      setConfigCliente(response?.data?.configClientes);

      const resGeneral = await api.post("/interno/find/generalSetting", {
        product: "suporte",
      });
      const fetchedSettings = resGeneral?.data || {};
      setSuporteGeneralSettings(fetchedSettings);
      const windowSetting =
        fetchedSettings?.duplicateTicketWindow ||
        fetchedSettings?.settings?.duplicateTicketWindow;
      if (windowSetting) {
        setDuplicateTicketWindow({
          ativo: windowSetting.ativo === true,
          valor: windowSetting.valor || 1,
          unidade: windowSetting.unidade || "horas",
        });
      }
    } catch (error) {
      console.error("Erro ao buscar configuração:", error);
      setSnackbar({
        children: "Erro ao buscar configuração!",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const updateDuplicateTicketWindow = async (newVal) => {
    setLoadingUpdate(true);
    try {
      const updatedSettings = {
        ...suporteGeneralSettings,
        duplicateTicketWindow: newVal,
      };
      await api.post("/interno/upsert/generalSettings", {
        product: "suporte",
        settings: updatedSettings,
      });
      setSuporteGeneralSettings(updatedSettings);
      setSnackbar({
        children: "Configuração de alerta de duplicidade salva!",
        severity: "success",
      });
    } catch (error) {
      console.error("Erro ao salvar configuração de duplicidade:", error);
      setSnackbar({
        children: "Erro ao salvar configuração!",
        severity: "error",
      });
    } finally {
      setLoadingUpdate(false);
    }
  };

  const updateConfigGlobal = async (
    id,
    openTicket,
    config,
    type,
    sendMessage = undefined,
    sendAnexo = undefined,
  ) => {
    //type 2 = liberação global (cliente), 3 = timeline cliente
    setLoadingUpdate(true);

    try {
      const response = await api.post("/interno/update/configClienteGlobal", {
        idConfigGlobal: id,
        openTicket: openTicket,
        config: config || null,
        sendMessage: sendMessage,
        sendAnexo: sendAnexo,
      });
      setConfigClienteGlobal((prev) => {
        return {
          ...prev,
          openTicket:
            response?.data?.openTicket !== undefined
              ? response?.data?.openTicket
              : prev?.openTicket,
          sendMessage:
            response?.data?.sendMessage !== undefined
              ? response?.data?.sendMessage
              : prev?.sendMessage,
          sendAnexo:
            response?.data?.sendAnexo !== undefined
              ? response?.data?.sendAnexo
              : prev?.sendAnexo,
          config:
            response?.data?.config !== undefined
              ? response?.data?.config
              : prev?.config,
        };
      });

      setSnackbar({
        children: "Configuração global de cliente atualizada com sucesso!",
        severity: "success",
      });
    } catch (error) {
      console.error("Erro ao atualizar configuração:", error);
      setSnackbar({
        children: "Erro ao atualizar configuração global!",
        severity: "error",
      });
    } finally {
      setLoadingUpdate(false);
    }
  };

  const updateConfigCliente = async (
    clienteId,
    openTicket,
    sendMessage,
    sendAnexo,
  ) => {
    setLoadingUpdate(true);
    try {
      const response = await api.post("/interno/update/configCliente", {
        clienteId: clienteId,
        openTicket: openTicket,
        sendMessage: sendMessage,
        sendAnexo: sendAnexo,
      });

      const updatedConfig = configCliente.map((config) =>
        config.id === response?.data?.clienteId
          ? {
              ...config,
              openTicket: response?.data?.openTicket,
              sendMessage: response?.data?.sendMessage,
              sendAnexo: response?.data?.sendAnexo,
            }
          : config,
      );

      setConfigCliente(updatedConfig);

      setSnackbar({
        children: "Configuração de cliente atualizada com sucesso!",
        severity: "success",
      });
    } catch (error) {
      console.error("Erro ao atualizar configuração do cliente:", error);
      setSnackbar({
        children: "Erro ao atualizar configuração do cliente!",
        severity: "error",
      });
    } finally {
      setLoadingUpdate(false);
    }
  };

  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Box sx={styles.containerHeader}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ManageAccountsOutlined color="primary" />
              <Typography
                variant="h5"
                sx={{
                  ...styles.title,
                }}
              >
                Configurações de cliente
              </Typography>
            </Box>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Paper variant="outlined" sx={styles.paperBody}>
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                <CircularProgress />
              </Box>
            ) : (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {erp === "HUBSOFT" && (
                  <Paper variant="outlined" sx={styles.paperContainer}>
                    <Box sx={styles.boxContainer}>
                      <Box sx={styles.switchesGroup}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  disabled={loadingUpdate}
                                  sx={styles.switch}
                                  checked={openTicketLiberadoGlobal}
                                  onChange={(e) => {
                                    setConfigClienteGlobal((prev) => ({
                                      ...prev,
                                      openTicket: e.target.checked,
                                    }));
                                    updateConfigGlobal(
                                      configClienteGlobal?.id,
                                      e.target.checked,
                                      null,
                                      2,
                                    );
                                  }}
                                  checkedIcon={<CheckCircle sx={styles.icon} />}
                                  icon={<Cancel sx={styles.icon} />}
                                  focusVisibleClassName=".Mui-focusVisible"
                                  disableRipple
                                />
                              }
                              sx={{ margin: 0 }}
                            />
                          </FormGroup>

                          <Box>
                            <Typography variant="body2" sx={styles.titleSwitch}>
                              Liberar abertura de ticket para todos os clientes.
                            </Typography>
                            <Typography sx={styles.subtitle}>
                              Quando ativado, todos os clientes terão permissão
                              para abrir tickets no sistema.
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  disabled={loadingUpdate}
                                  sx={styles.switch}
                                  checked={sendMessageLiberadoGlobal}
                                  onChange={(e) => {
                                    setConfigClienteGlobal((prev) => ({
                                      ...prev,
                                      sendMessage: e.target.checked,
                                    }));
                                    updateConfigGlobal(
                                      configClienteGlobal?.id,
                                      null,
                                      null,
                                      2,
                                      e.target.checked,
                                    );
                                  }}
                                  checkedIcon={<CheckCircle sx={styles.icon} />}
                                  icon={<Cancel sx={styles.icon} />}
                                  focusVisibleClassName=".Mui-focusVisible"
                                  disableRipple
                                />
                              }
                              sx={{ margin: 0 }}
                            />
                          </FormGroup>

                          <Box>
                            <Typography variant="body2" sx={styles.titleSwitch}>
                              Liberar envio de mensagem dentro do ticket para
                              todos os clientes.
                            </Typography>
                            <Typography sx={styles.subtitle}>
                              Quando ativado, todos os clientes poderão enviar
                              mensagens dentro dos tickets no sistema.
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  disabled={loadingUpdate}
                                  sx={styles.switch}
                                  checked={sendAnexoLiberadoGlobal}
                                  onChange={(e) => {
                                    setConfigClienteGlobal((prev) => ({
                                      ...prev,
                                      sendAnexo: e.target.checked,
                                    }));
                                    updateConfigGlobal(
                                      configClienteGlobal?.id,
                                      null,
                                      null,
                                      2,
                                      undefined,
                                      e.target.checked,
                                    );
                                  }}
                                  checkedIcon={<CheckCircle sx={styles.icon} />}
                                  icon={<Cancel sx={styles.icon} />}
                                  focusVisibleClassName=".Mui-focusVisible"
                                  disableRipple
                                />
                              }
                              sx={{ margin: 0 }}
                            />
                          </FormGroup>

                          <Box>
                            <Typography variant="body2" sx={styles.titleSwitch}>
                              Liberar anexo de arquivos dentro do ticket para
                              todos os clientes.
                            </Typography>
                            <Typography sx={styles.subtitle}>
                              Quando ativado, todos os clientes poderão anexar
                              arquivos dentro dos tickets no sistema.
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                      {!(
                        openTicketLiberadoGlobal &&
                        sendMessageLiberadoGlobal &&
                        sendAnexoLiberadoGlobal
                      ) && (
                        <TextField
                          label="Buscar cliente"
                          variant="outlined"
                          autoComplete="off"
                          placeholder="Cliente"
                          value={buscarCliente}
                          size="small"
                          onChange={(event) => {
                            setBuscarCliente(event?.target?.value?.trimStart());
                          }}
                          sx={styles.searchField}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Search />
                              </InputAdornment>
                            ),
                            endAdornment: buscarCliente ? (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={() => setBuscarCliente("")}
                                  edge="end"
                                >
                                  <Clear size={"small"} />
                                </IconButton>
                              </InputAdornment>
                            ) : null,
                          }}
                        />
                      )}
                    </Box>
                    <Collapse
                      in={
                        !(
                          openTicketLiberadoGlobal &&
                          sendMessageLiberadoGlobal &&
                          sendAnexoLiberadoGlobal
                        )
                      }
                    >
                      {" "}
                      <Paper
                        variant="outlined"
                        elevation={3}
                        sx={styles.paperDatagrid}
                      >
                        <DatagridComponent
                          columns={columnsCliente}
                          rows={filteredRows}
                        />
                      </Paper>
                    </Collapse>
                  </Paper>
                )}
                {erp === "HUBSOFT" && (
                  <Paper variant="outlined" sx={styles.paperContainer}>
                    <Box sx={styles.boxContainer}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                disabled={loadingUpdate}
                                sx={styles.switch}
                                checked={
                                  configClienteGlobal?.config
                                    ?.timelineCliente || false
                                }
                                onChange={(e) => {
                                  setConfigClienteGlobal((prev) => ({
                                    ...prev,
                                    config: {
                                      ...prev?.config,
                                      timelineCliente: e.target.checked,
                                    },
                                  }));
                                  updateConfigGlobal(
                                    configClienteGlobal?.id,
                                    null,
                                    {
                                      ...configClienteGlobal?.config,
                                      timelineCliente: e.target.checked,
                                    },
                                    3,
                                  );
                                }}
                                checkedIcon={<CheckCircle sx={styles.icon} />}
                                icon={<Cancel sx={styles.icon} />}
                                focusVisibleClassName=".Mui-focusVisible"
                                disableRipple
                              />
                            }
                            sx={{ margin: 0 }}
                          />
                        </FormGroup>
                        <Box>
                          <Typography variant="body2" sx={styles.titleSwitch}>
                            Exibir linha do tempo para o cliente
                          </Typography>
                          <Typography sx={styles.subtitle}>
                            Quando ativado, todos os clientes terão acesso à aba
                            'Linha do tempo' nos detalhes do ticket.
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                )}
                {erp === "HUBSOFT" && (
                  <Paper variant="outlined" sx={styles.paperContainer}>
                    <Box sx={styles.boxContainer}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          flexWrap: "wrap",
                          gap: 2,
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  disabled={loadingUpdate}
                                  sx={styles.switch}
                                  checked={duplicateTicketWindow.ativo === true}
                                  onChange={(e) => {
                                    const nextVal = {
                                      ...duplicateTicketWindow,
                                      ativo: e.target.checked,
                                    };
                                    setDuplicateTicketWindow(nextVal);
                                    updateDuplicateTicketWindow(nextVal);
                                  }}
                                  checkedIcon={<CheckCircle sx={styles.icon} />}
                                  icon={<Cancel sx={styles.icon} />}
                                  focusVisibleClassName=".Mui-focusVisible"
                                  disableRipple
                                />
                              }
                              sx={{ margin: 0 }}
                            />
                          </FormGroup>
                          <Box>
                            <Typography variant="body2" sx={styles.titleSwitch}>
                              Alerta de ticket duplicado por unidade
                            </Typography>
                            <Typography sx={styles.subtitle}>
                              Janela de tempo em que o sistema avisa se já
                              existe atendimento aberto para o mesmo serviço e
                              tipo.
                            </Typography>
                          </Box>
                        </Box>
                        {duplicateTicketWindow.ativo === true && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <TextField
                              label="Tempo"
                              type="text"
                              inputMode="numeric"
                              size="small"
                              sx={{ width: 90 }}
                              value={duplicateTicketWindow.valor}
                              disabled={loadingUpdate}
                              onChange={(e) => {
                                const rawValue = e.target.value.replace(
                                  /\D/g,
                                  "",
                                );
                                const val = Math.max(1, Number(rawValue));
                                setDuplicateTicketWindow((prev) => ({
                                  ...prev,
                                  valor: val,
                                }));
                              }}
                            />
                            <Select
                              size="small"
                              value={duplicateTicketWindow.unidade}
                              disabled={loadingUpdate}
                              onChange={(e) => {
                                setDuplicateTicketWindow((prev) => ({
                                  ...prev,
                                  unidade: e.target.value,
                                }));
                              }}
                            >
                              <MenuItem value="minutos">Minutos</MenuItem>
                              <MenuItem value="horas">Horas</MenuItem>
                              <MenuItem value="dias">Dias</MenuItem>
                              <MenuItem value="semanas">Semanas</MenuItem>
                              <MenuItem value="meses">Meses</MenuItem>
                            </Select>
                            <Button
                              variant="contained"
                              size="small"
                              disabled={loadingUpdate}
                              onClick={() =>
                                updateDuplicateTicketWindow(
                                  duplicateTicketWindow,
                                )
                              }
                            >
                              Salvar
                            </Button>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Paper>
                )}
              </Box>
            )}
          </Paper>
        </AccordionDetails>
      </Accordion>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </>
  );
}
